import { type FunctionComponent } from 'react';
import { I18nextProvider, type I18nextProviderProps } from 'react-i18next';
import { type i18n } from 'i18next';

interface I18nProviderProps extends Omit<I18nextProviderProps, 'i18n'> {
  i18nInstance: i18n;
}

const I18nProvider: FunctionComponent<I18nProviderProps> = ({ children, i18nInstance }) => (
  <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>
);

export { I18nProvider };
